// getters
const restaurantCategories = state => state.restaurantCategories

export default {
  restaurantCategories
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/categories/getters.js